// extracted by mini-css-extract-plugin
export default {"navItem":"style_navItem__lytw2","active":"style_active__I987N"};